module.exports = (__parcel__import__("b5EuA")).then(() => parcelRequire('2geSQ'));